import { Cookie } from './Cookie'

export class AuthCookie extends Cookie {
	public static getDomain = (environment: string): string => {
		let domain = 'localhost'
		switch (environment) {
			case 'dev':
				domain = 'localhost'
				break
			case 'nightly':
				domain = '.nightly.lynxcloud.app'
				break
			case 'beta':
				domain = '.beta.lynxcloud.app'
				break
			case 'production':
				domain = '.lynxcloud.app'
				break
		}
		return domain
	}

	public static create(environment: string, accessToken: string, refreshToken: string): void {
		const domain = AuthCookie.getDomain(environment)
		const bridge = refreshToken + ' ' + accessToken + ' ' + environment
		AuthCookie.set('lynxbridge', btoa(bridge), { SameSite: 'Strict', Path: '/', Domain: domain })
	}

	public static forceDelete(name: string, environment: string): void {
		const domain = AuthCookie.getDomain(environment)
		Cookie.set(name, '', { 'max-age': -1, ...{ SameSite: 'Strict', Path: '/', Domain: domain } })
	}
}
